export class BodyStampaReport {
    idRichiesta: number | undefined;
    parametri: ParametroBirt[] = [];
}

export class ParametroBirt {

    nome: string | undefined;
    valore: string | undefined;

    constructor(nome: string, valore: string) {
        this.nome = nome;
        this.valore = valore;
    }

}